import { render, staticRenderFns } from "./SurplusTreatyMasterList.vue?vue&type=template&id=80006410&"
import script from "./SurplusTreatyMasterList.vue?vue&type=script&lang=js&"
export * from "./SurplusTreatyMasterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports